module.exports = __webpack_public_path__ + "img/ico_tab3_coinstore@3x.78546485.png";